<div>
  <p-checkbox [formControl]="control" inputId="{{ randomId }}" [binary]="true" [attr.tabindex]="tabIndex"></p-checkbox>
  <label for="{{ randomId }}"></label>
</div>
